import Lottie from 'lottie-react'
import {useTranslation} from 'react-i18next'
import loaderAnimation from '../../assets/icons/loader.json'
import './styles.css'

type TLoaderVariant = 'fullscreen' | 'overlay' | 'inline'

interface LoaderProps {
  variant?: TLoaderVariant
  size?: number
  label?: string
  showLabel?: boolean
}

const SIZE_BY_VARIANT: Record<TLoaderVariant, number> = {
  fullscreen: 120,
  overlay: 96,
  inline: 40,
}

export default function Loader({
  variant = 'inline',
  size,
  label,
  showLabel = true,
}: LoaderProps) {
  const {t} = useTranslation()
  const dimension = size ?? SIZE_BY_VARIANT[variant]
  const text = label ?? t('common:loading')

  return (
    <div
      className={`loader loader--${variant}`}
      role='status'
      aria-live='polite'>
      <Lottie
        animationData={loaderAnimation}
        loop
        autoplay
        style={{width: dimension, height: dimension}}
      />
      {showLabel && <span className='loader__label'>{text}</span>}
    </div>
  )
}
